<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import fackClickOutSide from '@/utils/fackClickOutSide.js'
export default {
  name: 'App',
  mixins: [fackClickOutSide],
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,body{
  width: 100%;
  height: 100%;
  min-width: 1280px;
}
#app {
  height: 100%;
  // font-family: "SC-Normal";
  font-family:  Noto Sans SC;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
$--color-primary: #3135D7;

/* 改变 icon 字体路径变量，必需 */
$--font-path: '~element-ui/lib/theme-chalk/fonts';
@import "~element-ui/packages/theme-chalk/src/index";
</style>
